"use client"

import { useSyncExternalStore } from "react"

import {
  getLoginSession,
  getLoginSessionVersion,
  subscribeLoginSession,
  type LoginSession,
} from "@/lib/login-session"

export function useLoginSession(): LoginSession {
  useSyncExternalStore(
    subscribeLoginSession,
    getLoginSessionVersion,
    () => 0,
  )
  return getLoginSession()
}
